import MuiCollapse, { CollapseProps as MuiCollapseProps } from '@mui/material/Collapse';
import React, { PropsWithChildren } from 'react';

interface CollapseProps extends MuiCollapseProps {}

/**
 * A simple transition wrapper for collapsing elements.
 */
export const Collapse = ({ children, ...props }: PropsWithChildren<CollapseProps>) => {
	return <MuiCollapse {...props}>{children}</MuiCollapse>;
};
